import req from '../http.js';

// 获取pipeline控制列表
export const getExecutorSubmitterList = (params) => {
	return req('get', '/console/pipeline-control/getPipelineViewList', params);
};

export const executorStartByIp = (params) => {
	return req('get', '/console/pipeline-control/executorStartByIp', params);
};

export const executorStopByIp = (params) => {
	return req('get', '/console/pipeline-control/executorStopByIp', params);
};

export const getExecutorStatusByIp = (params) => {
	return req('get', '/console/pipeline-control/getExecutorStatusByIp', params);
};

export const submitterStartByIp = (params) => {
	return req('get', '/console/pipeline-control/submitterStartByIp', params);
};

export const submitterStopByIp = (params) => {
	return req('get', '/console/pipeline-control/submitterStopByIp', params);
};
export const getSubmitterStatusByIp = (params) => {

	return req('get', '/console/pipeline-control/getSubmitterStatusByIp', params);
};